import {QueryClient, QueryKey} from '@tanstack/react-query';

export function refetchAllOrderQueriesExceptDisabled(queryClient: QueryClient, queryKey: QueryKey): Promise<unknown> {
    return queryClient.refetchQueries({
        exact: false,
        type: 'active',
        queryKey,
        predicate(query) {
            const options: any = query.options;

            return options == null || !('enabled' in options) || options.enabled === true;
        }
    });
}
